import React from 'react';

const ContactMail = () => {
  return (
    <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_165_166)">
      <path d="M20.094 5.15625H5.65649C4.51741 5.15625 3.59399 6.07966 3.59399 7.21875V17.5313C3.59399 18.6703 4.51741 19.5938 5.65649 19.5938H20.094C21.2331 19.5938 22.1565 18.6703 22.1565 17.5313V7.21875C22.1565 6.07966 21.2331 5.15625 20.094 5.15625Z" stroke="#5F6177" stroke-width="2.0625" strokeLinecap="round" stroke-linejoin="round"/>
      <path d="M3.59399 7.21875L12.8752 13.4063L22.1565 7.21875" stroke="#5F6177" stroke-width="2.0625" strokeLinecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
      <clipPath id="clip0_165_166">
      <rect width="24.75" height="24.75" fill="white" transform="translate(0.500244)"/>
      </clipPath>
      </defs>
    </svg>

  )
}

export default ContactMail;